import React, { Component } from 'react';
import { AgGridReact } from '@ag-grid-community/react';
import { Loader } from 'semantic-ui-react';
import { ACTION_STATUS } from '../../../../../utils/ActionStatus';
import FormatUtil from '../../../../../utils/FormatUtil';
import '../../FundMonitoring.css';

class RuleMasterGrid extends Component {
    constructor(props) {
        super(props);
        this.state = {
            columnDefs: [
                { field: 'id', headerName: 'ID', cellClass: 'non-number', width: 90, headerCheckboxSelection: true, headerCheckboxSelectionFilteredOnly: true, checkboxSelection: true },
                { field: 'ruleId', headerName: 'Rule ID', cellClass: 'non-number', width: 130 },
                { field: 'status', headerName: 'Status', cellClass: 'non-number', width: 110, cellStyle: this.statusCellStyle },
                { field: 'category', headerName: 'Category', cellClass: 'non-number', width: 120 },
                { field: 'country', headerName: 'Country', cellClass: 'non-number', width: 110 },
                { field: 'fund', headerName: 'Fund', cellClass: 'non-number', width: 100 },
                { field: 'expType', headerName: 'Exposure Type', cellClass: 'non-number', width: 130 },
                { field: 'expMeasure', headerName: 'Exposure Measure', cellClass: 'non-number', width: 150 },
                { field: 'expMetric', headerName: 'Exposure Metric', cellClass: 'non-number', width: 130 },
                { field: 'assetClass', headerName: 'Asset Class', cellClass: 'non-number', width: 100 },
                {
                    field: 'reportThreshold',
                    headerName: 'Report Threshold',
                    width: 130,
                    valueFormatter: params => {
                        const expMetric = params.data && params.data.expMetric;
                        if (expMetric && expMetric.toLowerCase().includes('pct')) {
                            return FormatUtil.percentValueFormatter1(params);
                        }
                        return FormatUtil.numValueFormatter1(params);
                    }
                },
                {
                    field: 'alertThreshold',
                    headerName: 'Alert Threshold',
                    width: 130,
                    valueFormatter: params => {
                        const expMetric = params.data && params.data.expMetric;
                        if (expMetric && expMetric.toLowerCase().includes('pct')) {
                            return FormatUtil.percentValueFormatter1(params);
                        }
                        return FormatUtil.numValueFormatter1(params);
                    }
                },
                { field: 'deadline', headerName: 'Deadline', cellClass: 'non-number', width: 220, tooltipField: 'deadline' },
                { field: 'effectiveFromLabel', headerName: 'Effective From', cellClass: 'non-number', width: 150 },
                { field: 'effectiveToLabel', headerName: 'Effective To', cellClass: 'non-number', width: 150 },
                { field: 'remarks', headerName: 'Remarks', cellClass: 'non-number', width: 280, tooltipField: 'remarks' },
                { field: 'lastModifiedDateLabel', headerName: 'Last Modified Date', cellClass: 'non-number', width: 150 },
                { field: 'lastModifiedBy', headerName: 'Last Modified By', cellClass: 'non-number', width: 120 },
            ],
            defaultColDef: {
                enableCellChangeFlash: true,
                minWidth: 80,
                sortable: true,
                filter: true,
                resizable: true,
            },
            sideBar: {
                toolPanels: ['columns', 'filters'],
                defaultToolPanel: '',
            },
            rowSelection: 'multiple',
            statusBar: {
                statusPanels: [
                    { statusPanel: 'agTotalAndFilteredRowCountComponent', align: 'left' },
                    { statusPanel: 'agSelectedRowCountComponent' },
                ],
            },
        };
    }

    statusCellStyle(param) {
        if (param.value === 'Active') {
            return { color: '#0b8f36', fontWeight: 'bold' };
        }
        return { fontWeight: 'bold' };
    }

    getRowNodeId = data => data.id;

    onGridReady = grid => {
        this.props.addRuleMasterGridToProps(grid);
    };

    onSelectionChanged = event => {
        const rowNodeArray = event.api.getSelectedNodes();
        this.props.selectRuleMaster(rowNodeArray.map(rowNode => rowNode.data));
    };

    normalizeDataArray(resp) {
        if (!resp) {
            return [];
        }
        const data = resp.data;
        if (Array.isArray(data)) {
            return data;
        }
        if (data && Array.isArray(data.list)) {
            return data.list;
        }
        if (data && Array.isArray(data.data)) {
            return data.data;
        }
        if (data && data.id !== undefined) {
            return [data];
        }
        return [];
    }

    filterRows(rows) {
        const { category, fund, showAll } = this.props.ruleMasterQueryFields;
        return rows.filter(row => {
            const categoryMatched = !category || category === 'All' || row.category === category;
            const fundMatched = !fund || fund === 'All' || row.fund === fund;
            const statusMatched = showAll || row.status === 'Active';
            return categoryMatched && fundMatched && statusMatched;
        });
    }

    render() {
        const {
            loadRuleMasterActionStatus,
            loadRuleMasterActionResp,
        } = this.props;

        const isLoading = loadRuleMasterActionStatus === ACTION_STATUS.LOGINING;
        const dataArray = this.filterRows(this.normalizeDataArray(loadRuleMasterActionResp));

        return (
            <div className="ag-theme-balham grid-wrapper">
                {isLoading ? (
                    <Loader active content="Loading..." />
                ) : (
                    <AgGridReact
                        columnDefs={this.state.columnDefs}
                        rowData={dataArray}
                        defaultColDef={this.state.defaultColDef}
                        rowSelection={this.state.rowSelection}
                        suppressRowClickSelection={true}
                        suppressAggFuncInHeader={true}
                        animateRows={true}
                        immutableData={false}
                        enableRangeSelection={true}
                        getRowNodeId={this.getRowNodeId}
                        sideBar={this.state.sideBar}
                        statusBar={this.state.statusBar}
                        onGridReady={this.onGridReady}
                        onSelectionChanged={this.onSelectionChanged}
                    />
                )}
            </div>
        );
    }
}

export default RuleMasterGrid;
